import { Button, DatePicker, Empty, Form, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import Loading from "../common/Loader";
import axios from "axios";
import moment from "moment";
import BreadCrumb from "../Layouts/Breadcrumb";
import { jcTypeArray, OrderTypeArray } from "../../utils";
import { debounce } from "lodash";
import styles from "../../styles/tailwind/List.module.css";
import { useSelector } from "react-redux";
import Loader from "../common/Loader";
import { useParams } from "react-router";
import TopHeading from "./TopHeading";

const { RangePicker } = DatePicker;

const ReturnSalesProductDetailsReportList = () => {
  const { token } = useSelector((state) => (state as any)?.authReducer);
  const initialState = useSelector((state) => (state as any)?.authReducer);
  const [type, setType] = useState(initialState?.type);
  const [form] = Form.useForm();
  const route = useParams();
  const shopId = (route as any)?.shopId;
  const [hubId, setHubId] = useState<any>();
  const [status, setStatus] = useState<any>();
  const [showSearch, setShowSearch] = useState(true);
  const [range, setRange] = useState<any>({
    from: null,
    to: null,
  });

  const [salesData, setSalesData] = useState<any>({
    loading: false,
    data: null,
  });

  const [downloadData, setDownloadData] = useState<any>({
    loading: false,
    data: null,
  });

  const getSalesReport = useCallback(async () => {
    const from = moment(range.from)?.toISOString();
    const to = moment(range.to)?.toISOString();
    setSalesData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_ORDER_API}`;
    axios
      .get(
        `${encodedUri}/report/return-top-sales-product-details-report` +
          (type ? `?type=${type}` : ``) +
          (shopId ? `&shopId=${shopId}` : ``) +
          (from ? `&startFrom=${from}` : ``) +
          (to ? `&endAt=${to}` : ``) +
          (status ? `&status=${status}` : ``),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        setSalesData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setSalesData({ loading: false, data: [] });
        console.error("Data: Error", err);
      });
  }, [type, shopId, range.from, range.to, status]);

  const getSalesReportDownload = useCallback(async () => {
    const from = moment(range.from)?.toISOString();
    const to = moment(range.to)?.toISOString();

    setDownloadData({ loading: true, data: null });

    const encodedUri = `${process.env.REACT_APP_ORDER_API}`;
    const url =
      `${encodedUri}/report/return-top-sales-product-details-report?page=0` +
      (type ? `&type=${type}` : ``) +
      (shopId ? `&shopId=${shopId}` : ``) +
      (from ? `&startFrom=${from}` : ``) +
      (to ? `&endAt=${to}` : ``) +
      (status ? `&status=${status}` : ``);

    try {
      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
      });

      const blob = await response.blob();
      setDownloadData({ loading: false, data: blob });

      const fileURL = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = fileURL;
      link.setAttribute(
        "download",
        `Sales_Report-${moment(range.from).format("YYYY_MM_DD")}-${moment(
          range.to
        ).format("YYYY_MM_DD")}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error("Data: Error", err);
      setDownloadData({ loading: false, data: null });
    }
  }, [type, shopId, range.from, range.to, status, token]);

  const fetchRef: any = useRef(null);
  useEffect(() => {
    getSalesReport();
  }, [getSalesReport]);

  const reseAllFieldData = () => {
    form.resetFields();
    setStatus("");
    setRange({
      from: null,
      to: null,
    });
  };

  return (
    <React.Fragment>
      <TopHeading
        {...salesData?.data?.totalElements}
        refetch={getSalesReport}
        title={"Sales Report"}
        download={() => getSalesReportDownload()}
        dissable={!salesData?.data?.returnSalesTopProductsOrderSummaryResponses?.length}
        loading={downloadData?.loading}
      />
      <BreadCrumb
        title="Return Sales Product Details Report"
        subTitle={`${salesData?.data?.totalElements} Order(s)`}
        extra={[
          <Button
            type="dashed"
            shape="circle"
            onClick={() => setShowSearch(!showSearch)}
            key={1}
          >
            <SearchOutlined />
          </Button>,
        ]}
      />
      {showSearch && (
        <div className={`${styles.searchBox}`}>
          <Form form={form} layout="inline" className={styles.formInline}>
            <Form.Item initialValue={type}>
              <Select
                placeholder="Shop Type"
                onChange={(val) => setType(val)}
                value={type}
                style={{ width: 250 }}
              >
                {Object.values(jcTypeArray)?.map((type, i) => (
                  <Option value={type} key={i}>
                    {type.replace("_", " ")}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item name="range">
              <RangePicker
                defaultValue={
                  range.from != null && range.to != null
                    ? [moment(range.from), moment(range.to)]
                    : null
                }
                onChange={(e, f) => {
                  setRange({ from: f?.[0], to: f?.[1] });
                }}
                showTime={{
                  hideDisabledOptions: true,
                  defaultValue: [
                    moment("00:00:00", "HH:mm:ss"),
                    moment("23:59:59", "HH:mm:ss"),
                  ],
                }}
                inputReadOnly
                allowClear
              />
            </Form.Item>
            <Form.Item name="status_search" initialValue={status}>
              <Select
                showSearch
                placeholder="Filter by Status"
                onChange={(val) => setStatus(val)}
              >
                <Select.Option value="">ALL STATUS</Select.Option>
                {Object.values(OrderTypeArray)?.map((type, i) => (
                  <Select.Option value={type} key={i}>
                    {type?.split("_").join(" ")}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Form>
          <Button type="primary" danger size="large" onClick={reseAllFieldData}>
            Reset
          </Button>
        </div>
      )}
      <div className="content-body_ rounded-2xl">
        <div className="bg-white shadow-lg shadow-gray-200 rounded-2xl p-0 mb-6">
          <div className={styles.contentWrapper}>
            <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="py-2 inline-block min-w-full sm:px-6 lg:px-8">
                <div
                  className={
                    showSearch ? `content-body-withSearch` : `content-body`
                  }
                >
                  {salesData?.loading ? (
                    <Loader />
                  ) : (
                    <table className={styles.mainTable}>
                      <thead className="bg-white border-b">
                        <tr>
                          <th scope="col">createdAt</th>
                          <th scope="col">Total Orders</th>
                          <th scope="col">Merchant Price</th>
                          <th scope="col">Product Price</th>
                          <th scope="col">Sale Price</th>
                        </tr>
                      </thead>

                      <tbody>
                        {salesData?.data?.returnSalesTopProductsOrderSummaryResponses?.length ? (
                          salesData?.data?.returnSalesTopProductsOrderSummaryResponses?.map(
                            (salesData: any, index: any) => (
                              <tr
                                className="border-t hover:bg-gray-100"
                                key={index}
                              >
                                <td>
                                  <span className="name">
                                    {moment(salesData?.createdAt).format("lll")}
                                  </span>
                                </td>
                                <td>
                                  <span className="name">
                                    {salesData?.totalOrders}
                                  </span>
                                </td>
                                <td>
                                  <span className="name">
                                    {salesData?.merchantPrice}
                                  </span>
                                </td>
                                <td>
                                  <span className="name">
                                    {salesData?.productPrice}
                                  </span>
                                </td>
                                <td>
                                  <span className="name">
                                    {salesData?.salePrice}
                                  </span>
                                </td>
                                
                              </tr>
                            )
                          )
                        ) : (
                          <tr>
                            <td>
                              <Empty />
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ReturnSalesProductDetailsReportList;
